import { render, staticRenderFns } from "./NewChildAppointments.vue?vue&type=template&id=8b712756&scoped=true&"
import script from "./NewChildAppointments.vue?vue&type=script&lang=js&"
export * from "./NewChildAppointments.vue?vue&type=script&lang=js&"
import style0 from "./NewChildAppointments.vue?vue&type=style&index=0&id=8b712756&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b712756",
  null
  
)

export default component.exports